<template>
    <div class="footer">
        <div class="footer_top">
            <div class="left">
                <span>
                    托乐乐·云端助教
                </span>
                <span>
                    托乐乐隶属于上海优思教育集团，国内首家专注于晚托班服务<br>
                    结合人工智能&线下高端晚托班店铺，为小学学生及家长提供优质服务！
                </span>
            </div>
            <div class="middle">
                <span>
                    <router-link to='/home/index'>首页</router-link>
                </span>
                <span>
                    <router-link to='/home/aboutus'>关于云端助教</router-link>
                </span>
                <span>
                    <a href="https://assistant.tuolele.cn/index.html"  target="view_windo">加入我们</a>
                </span>
            </div>
            <div class="right">
                
            </div>
        </div>
        <div class="border"></div>
        <div class="footer_bottom">
             <span>© 2019 TUOLELE 上海剑优网络科技有限公司 沪ICP备15035929号</span>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return { 

        }
    }
}
</script>

<style scoped lang='scss'>
a:hover {
    color: #fff!important;
}

.footer {
    width: 100%;
    height: 285px;
    background-color: #384258;
    span {
        display: block;
    }
    .footer_top {
        max-width: 1200px;
        min-width: 1100px;
        height: 229px;
        margin: 0 auto;
        .left,
        .middle,
        .right {
            float: left;
        }
        .left {
            width: 355px;
            margin-top: 46px;
            span {
                &:first-child {
                    font-size: 24px;
                    color: #fefefe;
                    margin-bottom: 22px;
                }
                &:last-child {
                    font-size: 12px;
                    color: #98a4b9;
                    line-height: 20px;
                }
            }
        }
        .middle {
            margin-left: 213px;
            span {
                &:first-child {
                    margin: 65px 0 40px 0;
                }
                &:last-child {
                    margin-top: 40px;
                }
            }
            a {
                color: #8f9bb1;
            }
        }
    }
    .border {
        border-bottom: 1px solid #414d69;
    }
    .footer_bottom {
        max-width: 1200px;
        height: 55px;
        line-height: 55px;
        color: #59708b;
        font-size: 12px;
        margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue